// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__MK6RV","flexSizes12":"Columns_flexSizes12__PvyG8","flexSizes23":"Columns_flexSizes23___oKnd"};